import { Injectable } from "@angular/core";
import { constants } from "src/app/config/constant";
import { environment } from "src/environments/environment";
import { SignalrService } from "./signalr.service";
@Injectable({
  providedIn: 'root',
})
export class LockdownService {
  connection = (<any>$).hubConnection(this.config.LOCKDOWN_ENDPOINT) as any
  proxy: any;
  connected = false
  throttle: any;
  constructor(public config: constants, public signalR: SignalrService) {

  }

  connect() {
    this.proxy = this.connection.createHubProxy("lockdownClientHub");

    return new Promise((resolve, reject) => {
      if (!this.config.KIOSK_ENABLED) {
        this.signalR.log('AppLog_Info', { message: 'Kiosk features are disabled.' })
        this.connected = true
        resolve(this)
      }
      this.connection.start().done(() => {
        // calls to lockdown here
        this.connected = true
        resolve(this)
      }).catch((error: any) => {
        reject(error)
      })
    })
  }

  async setUserPresent(): Promise<void> {
    return new Promise((resolve, reject) => {
      clearTimeout(this.throttle)
      this.throttle = setTimeout(async () => {
        if (!this.config.KIOSK_ENABLED) {
          resolve()
        }
        if (!this.connected) {
          await this.connect()
        }
        this.proxy.invoke('SetUserPresent')
          .finally(() => {
            resolve()
          })
      }, 100);
    })
  }
}
